export enum BlurAmount {
  LIGHT = '2px',
  INTENSE = '6px',
}
